import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SearchConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ConsultantSearchService } from './api/consultantSearch.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SearchApiModule {
    public static forRoot(configurationFactory: () => SearchConfiguration): ModuleWithProviders<SearchApiModule> {
        return {
            ngModule: SearchApiModule,
            providers: [ { provide: SearchConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SearchApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SearchApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
